/**
 *
 * @param object
 * @param array keys
 * @param value
 */
function addToObject(object, keys, value) {
	let myKey = keys.pop();
	if ( myKey == false || myKey == '') {
		alert('dit kan niet');
		return;
	}
	if (keys.length == 0) {
		object[myKey] = value
		return;
	} else {
		if (! object.hasOwnProperty(myKey)) {
			object[myKey] = {};
		}
		addToObject(object[myKey], keys, value);
	}
}

function addPairs(pairs) {
	let result = {};
	console.log(pairs);
	pairs.forEach(function( obj) {
		let pattern = /[a-z0-9_]+|(?=\[\])/gi;
		let keys = obj.name.match(pattern);
		console.log(keys.reverse(), obj)
		addToObject(result, keys, obj.value);
	})
	return result;
}
export default addPairs;